/**
 * Maps question numbers to image files under client/public/asset/images/ability-test/.
 * Simplified papers use displayNumber 1–10; assets are paired sheets (NRT) or per-question (LRT).
 */

// Support deployments under a sub-path (CRA `PUBLIC_URL`), e.g. https://host/app
// In that case absolute `/asset/...` would 404; prefix with PUBLIC_URL.
const PUBLIC_URL = (typeof process !== 'undefined' && process?.env?.PUBLIC_URL) || '';
const ABILITY_TEST_IMG_BASE = `${PUBLIC_URL}/asset/images/ability-test`;

function encodeAssetPath(...segments) {
  return [ABILITY_TEST_IMG_BASE, ...segments.map((s) => encodeURIComponent(s))].join('/');
}

/** @type {[number, number, string][]} inclusive displayNumber ranges → filename in NRT/ */
const NRT_RANGE_FILES = [
  [1, 2, 'NRT 1-2.png'],
  [3, 4, 'NRT 3-4.png'],
  [5, 6, 'NRT 5-6.png'],
  [7, 8, 'NRT 7-8.png'],
  [9, 10, 'NRT 9-10.png']
];

/**
 * @param {number} displayNumber 1–10 (simplified NRT)
 */
export function nrtQuestionImageUrl(displayNumber) {
  const n = Number(displayNumber);
  for (const [lo, hi, file] of NRT_RANGE_FILES) {
    if (n >= lo && n <= hi) {
      return encodeAssetPath('NRT', file);
    }
  }
  return null;
}

/**
 * @param {number} displayNumber 1–10 (simplified LRT)
 */
export function lrtQuestionImageUrl(displayNumber) {
  const n = Number(displayNumber);
  if (n >= 1 && n <= 10) {
    return encodeAssetPath('LRT', `LRT ${n}.png`);
  }
  return null;
}
